export default __webpack_public_path__ + "static/summer_containers35-0eb38b9fe39ecf783771f926aed1f2a1.webp";